<template>
  <div>
    <h3>DB Test</h3>

    <textarea v-model="query" rows="5" style="width:100%"></textarea>

    <button @click="run" :disabled="loading">
      {{ loading ? 'Çalışıyor...' : 'Çalıştır' }}
    </button>

    <div v-if="error" style="margin-top:10px;color:#b91c1c">
      Hata: {{ error }}
    </div>

    <div v-if="result" style="margin-top:10px">
      <div>MS: {{ result.ms }}</div>
      <div>RowsAffected: {{ result.rowsAffected }}</div>
      <pre style="background:#111;color:#fff;padding:10px;overflow:auto">{{ result.recordset }}</pre>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      error: '',
      result: null,
      // NOT: gerçek projede db bilgisini frontend'e koyma.
      // Test için bile backend tarafında saklamak daha doğru.
      db: {
  "server":"188.132.203.200",
  "port":"",
  "user":"b2byapas",
  "password":"Yapas@2025*-",
  "database":"MikroDesktop_01"
}
,
      query: "SELECT TOP (20) * FROM INFORMATION_SCHEMA.TABLES"
    };
  },
  created() { this.$store.setLoading([false,'Bekleyiniz']) },
  methods: {
    async run() {
      this.loading = true;
      this.error = '';
      this.result = null;

      try {
        const r = await fetch('https://api.projemikro.com/testdb/test-query', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            db: this.db,
            query: this.query,
            params: []
          })
        });

        const data = await r.json();
        if (!r.ok || !data.ok) throw new Error(data.error || 'Bilinmeyen hata');

        this.result = data;
      } catch (e) {
        this.error = e.message || String(e);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/test.vue